var map = {
	"./accordion-arrow.svg": 728,
	"./arrow.svg": 729,
	"./bigcommerce-logo.svg": 730,
	"./magento1-logo.svg": 731,
	"./magento2-logo.svg": 732,
	"./opencart-logo.svg": 733,
	"./prestashop-logo.svg": 734,
	"./shopify-logo.svg": 735,
	"./shopware-logo.svg": 736,
	"./trustpilot-logo.svg": 737,
	"./woocommerce-logo.svg": 738
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 727;


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images ^\.\/.*\.svg$
// module id = 727
// module chunks = 0